import validationPatterns from '../../ES_App/util/validationPatterens'

export const dispCountry = 'transportation.dispatchCountry'
export const destCountry = 'transportation.countryOfDestination'
export const goodsLocation = 'transportation.locationOfGoods'
export const containerIndicator = 'transportation.container'
export const borderTransMode = 'transportation.transport.borderTransportMode'
export const natureOfTrans = 'transportation.natureOfTransaction'
export const custOfficeOfExit = 'transportation.customsOfficeOfExit'

const createPartiesPattern = () => {
  return ['exporter', 'consignee', 'declarant', 'representative', 'carrier'].reduce(
    (prev, curr) => {
      return {
        ...prev,
        [`${curr}.name`]: {
          presence: false,
          length: {
            maximum: 35,
            message: `^Length of ${curr.toUpperCase()} NAME should be maximum 35 characters.`,
          },
          format: {
            pattern: validationPatterns.P.pattern,
            message: `^${curr.toUpperCase()} NAME can only contain A - Z, a - z, 0 – 9, space, "+" full-stop, comma, hyphen, (, ), /, ', +, colon, =, ?, !, \", %, &, *, semi-colon, <  and >.`,
          },
        },
        [`${curr}.eoriNo`]: {
          presence: false,
          length: {
            maximum: 17,
            message: `^Length of ${curr.toUpperCase()} EORI NUMBER should be maximum 17 characters.`,
          },
          format: {
            pattern: validationPatterns.AN.pattern,
            message: `^${curr.toUpperCase()} EORI NUMBER can only contain Alpha Numeric characters .`,
          },
        },
        [`${curr}.addressLine1`]: {
          presence: false,
          length: {
            maximum: 35,
            message: `^$Length of ${curr.toUpperCase()} ADDRESS LINE 1 should be maximum 35 characters.`,
          },
          format: {
            pattern: validationPatterns.Address.pattern,
            message: `^${curr.toUpperCase()} ADDRESS LINE 1 can only contain alphanumeric, comma, dot and space characters.`,
          },
        },
        [`${curr}.addressLine2`]: {
          presence: false,
          length: {
            maximum: 35,
            message: `^$Length of ${curr.toUpperCase()} ADDRESS LINE 2 should be maximum 35 characters.`,
          },
          format: {
            pattern: validationPatterns.Address.pattern,
            message: `^${curr.toUpperCase()} ADDRESS LINE 2 can only contain alphanumeric, comma, dot and space characters.`,
          },
        },
        [`${curr}.city`]: {
          presence: false,
          length: {
            maximum: 35,
            message: `^Length of ${curr.toUpperCase()} CITY should be maximum 35 characters.`,
          },
          format: {
            pattern: validationPatterns.Address.pattern,
            message: `^${curr} CITY can only contain alphanumeric,comma, dot and space characters.`,
          },
        },
        [`${curr}.state`]: {
          presence: false,
          length: {
            maximum: 35,
            message: `^Length of ${curr.toUpperCase()} STATE should be maximum 35 characters.`,
          },
          format: {
            pattern: validationPatterns.Address.pattern,
            message: `^${curr} STATE can only contain alphanumeric,comma, dot and space characters.`,
          },
        },
        [`${curr}.postalCode`]: {
          presence: false,
          length: {
            maximum: 9,
            message: `^Length of ${curr.toUpperCase()} POSTAL CODE should be maximum 9 characters.`,
          },
          format: {
            pattern: validationPatterns.POSTAL_CODE.pattern,
            message: `^${curr} POSTAL CODE can only contain alphanumeric characters.`,
          },
        },
      }
    },
    {}
  )
}

const cdsFieldPatternCommon = (dependentParams) => {
  return {
    header: {
      declarationCat: {
        presence: { message: '^DECLARATION CATEGORY is mandatory', allowEmpty: false },
      },
      declaration:(value, attributes) => (       {
        presence: ['B1','C1', 'B2', 'B4','C21E','C21EEID'].includes(attributes?.declarationCat)
          ? { message: '^DECLARATION is mandatory', allowEmpty: false }
          : false
      }),
      declarationType: (value, attributes) => ({
        presence: ['B1','C1', 'B2', 'B4','C21E','C21EEID'].includes(attributes?.declarationCat)
          ? { message: '^DECLARATION TYPE is mandatory', allowEmpty: false }
          : false
      }),
      referenceNumber: {
        presence: false,
        length: {
          minimum: 0,
          maximum: 35,
          message: `^max length of REFERENCE NUMBER / UCR should be 35`,
        },
        format: {
          pattern: validationPatterns.V.pattern,
          message: `^REFERENCE NUMBER / UCR can only contain ${validationPatterns.V.description}`,
        },
      },
      specificCircumstanceIndicator: {
        presence: false,
        length: {
          minimum: 3,
          maximum: 3,
          message: `^length of SPECIFIC CIRCUMSTANCE INDICATOR should be exactly 3`,
        },
        format: {
          pattern: validationPatterns.AN.pattern,
          message: `^SPECIFIC CIRCUMSTANCE INDICATOR can only contain ${validationPatterns.AN.description} characters`,
        },
      },
      [dispCountry]: (value, attributes) => ({
        presence: ['B1', 'B2', 'B4'].includes(attributes?.declarationCat)
          ? { message: '^DISPATCH COUNTRY is mandatory', allowEmpty: false }
          : false,
      }),
      [destCountry]: {
        presence: false,
      },
      [goodsLocation]: (value, attributes) => ({
        presence: ['B1','C1', 'B2', 'B4','C21E','C21EEID'].includes(attributes?.declarationCat)
          ? { message: '^LOCATION OF GOODS is mandatory', allowEmpty: false }
          : false,
      }),
      [containerIndicator]: (value, attributes) => ({
          presence: ['B1','C1', 'B2', 'B4','C21EEID'].includes(attributes?.declarationCat)
          ? { message: '^CONTAINER INDICATOR is mandatory', allowEmpty: false }
          : false,
      }),
      [borderTransMode]: (value, attributes) => ({
        presence: ['B1', 'B2', 'B4', 'C21EEIDR'].includes(attributes?.declarationCat)
          ? { message: '^BORDER TRANSPORT MODE is mandatory', allowEmpty: false }
          : false,
      }),
      [natureOfTrans]: (value, attributes) => ({
        presence: false
         }),
      [custOfficeOfExit]: (value, attributes) => ({
        presence: ['B1', 'B2', 'C1','B4','C21E','C21EEIDR'].includes(attributes?.declarationCat)
          ? { message: '^CUSTOM OFFICE OF EXIT is mandatory', allowEmpty: false }
          : false,
      }),
    },
    parties: createPartiesPattern(),
    valueBuildUp: {},
    items: {
      invoice: () => ({}),
      lineItem: (inIdx, liIdx) => ({
        commercialDescription: {
          presence: ['B1', 'B2', 'C1', 'B4'].includes(dependentParams?.declarationCat) ?
            { allowEmpty: false, message: `^${(inIdx && liIdx) ? `Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` : ""} DESCRIPTION OF GOODS is mandatory` } : false,
          format: {
            pattern: validationPatterns.P.pattern,
            message: `^${(inIdx && liIdx) ? `Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` : ""} DESCRIPTION OF GOODS A - Z, a - z, 0 – 9, space, "+" full-stop, comma, hyphen, (, ), /, ', +, colon, =, ?, !, \", %, &, *, semi-colon, <  and >`
          },
          length: {
            maximum: 280,
            message: `^${(inIdx && liIdx) ? `Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` : ""} max length of DESCRIPTION OF GOODS should be 280`
          }
        },
        commodityCode: {
          presence: ['B1', 'B2', 'B4'].includes(dependentParams?.declarationCat) ?
            { allowEmpty: false, message: `^${(inIdx && liIdx) ? `Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` : ""} HTS CODE is mandatory` } : false,
        },
        destinationCountry: {
          presence: false,
        },
        supplementUnits: {
          format: {
            pattern: validationPatterns.N16D6.pattern,
            message: `^${(inIdx && liIdx) ? `Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` : ""} SUPPLEMENTAL UNITS can contains ${validationPatterns.N16D6.description}`
          }
        },
        natureOfTransaction: {
          presence: false
        },
        packageCount: {
          presence: ['B1', 'C1', 'B2', 'B4', 'C21EEIDR'].includes(dependentParams?.declarationCat) ?
            { allowEmpty: false, message: `^${(inIdx && liIdx) ? `Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` : ""} NUMBER OF PACKAG is mandatory` } : false,
          length: {
            maximum: 5,
            message: `^${(inIdx && liIdx) ? `Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` : ""} max length of NUMBER OF PACKAG should be 5`
          }
        },
        packageType: {
          presence: ['B1', 'C1', 'B2', 'B4', 'C21EEIDR'].includes(dependentParams?.declarationCat) ?
            { allowEmpty: false, message: `^${(inIdx && liIdx) ? `Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` : ""} TYPE OF PACKAGES is mandatory` } : false,
        },
        statisticalValue: {
          format: {
            pattern: validationPatterns.N15D2.pattern,
            message: `^${(inIdx && liIdx) ? `Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` : ""} STATISTICAL VALUE can contains ${validationPatterns.N15D2.description}`
          }
        },
        grossMass: {
          presence: ['B1', 'B2', 'C21EEIDR'].includes(dependentParams?.declarationCat) ?
            { allowEmpty: false, message: `^${(inIdx && liIdx) ? `Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` : ""} GROSS MASS is mandatory` } : false,
          format: {
            pattern: validationPatterns.N11D3.pattern,
            message: `^${(inIdx && liIdx) ? `Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` : ""} GROSS MASS can contains ${validationPatterns.N11D3.description}`
          }
        },
        netMass: {
          presence: ['B1', 'B2'].includes(dependentParams?.declarationCat) ?
            { allowEmpty: false, message: `^${(inIdx && liIdx) ? `Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` : ""} NET MASS is mandatory` } : false,
          format: {
            pattern: validationPatterns.N11D3.pattern,
            message: `^${(inIdx && liIdx) ? `Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` : ""} NET MASS can contains ${validationPatterns.N11D3.description}`
          }
        },
        shippingMarks: {
          presence: ['B1', 'C1', 'B2', 'B4', 'C21EEIDR'].includes(dependentParams?.declarationCat) ?
            { allowEmpty: false, message: `^${(inIdx && liIdx) ? `Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` : ""} SHIPPING MARKS is mandatory` } : false,
          format: {
            pattern: validationPatterns.P.pattern,
            message: `^${(inIdx && liIdx) ? `Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` : ""} SHIPPING MARKS A - Z, a - z, 0 – 9, space, "+" full-stop, comma, hyphen, (, ), /, ', +, colon, =, ?, !, \", %, &, *, semi-colon, <  and >`
          },
          length: {
            maximum: 42,
            message: `^${(inIdx && liIdx) ? `Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` : ""} max length of SHIPPING MARKS should be 42`
          }
        },
        procedures: {
          presence: ['B1', 'C1', 'B2', 'B4', 'C21EEIDR'].includes(dependentParams?.declarationCat) ?{
            allowEmpty: false, message: `^${(inIdx && liIdx) ? `Invoice 00${inIdx} :: LineItem 00${liIdx} :: ` : ""} PROCEDURE is mandatory`
          }:false
        }
      }),
      additionalDoc: () => ({}),
      prevDoc: () => ({})
    },
    containers: {
      containerNumber: {
        presence: {
          message: `^${dependentParams?.conIdx ? `Container 00${dependentParams?.conIdx + 1} :: ` : ''
            } NUMBER is mandatory`,
          allowEmpty: false,
        },
        length: {
          minimum: 0,
          maximum: 17,
          message: `^${dependentParams?.conIdx ? `Container 00${dependentParams?.conIdx + 1} :: ` : ''
            } max length of NUMBER should be 17`,
        },
        format: {
          pattern: validationPatterns.AN.pattern,
          message: `^${dependentParams?.conIdx ? `Container 00${dependentParams?.conIdx + 1} :: ` : ''
            } NUMBER can only contain ${validationPatterns.AN.description} characters`,
        },
      },
      sealNumber: {},
      sizeType: {},
      totalPackages: {},
      grossMass: {},
    },
  }
}

export const cdsFieldPatterns = (isImportShipment) => {
  if (isImportShipment) {
    return (dependentParams = {}) => ({
      header: {},
      parties: {},
      valueBuildUp: {},
      items: {
        invoice:()=>({}),
        lineItem:()=>({}),
        additionalDoc:()=>({}),
        prevDoc:()=>({})
      },
      containers: {},
    })
  }
  return (dependentParams = {}) => ({
    header: {
      ...cdsFieldPatternCommon(dependentParams).header,
    },
    parties: {
      ...cdsFieldPatternCommon(dependentParams).parties
    },
    valueBuildUp: {},
    items: {
      ...cdsFieldPatternCommon(dependentParams).items,
      lineItem: (inIdx, liIdx) => ({
        ...cdsFieldPatternCommon(dependentParams).items.lineItem(inIdx, liIdx),
      })
    },
    containers: {
      ...cdsFieldPatternCommon(dependentParams).containers,
    },
  })
}
